<div class="chat-rail-travelcards-card">
  <p class="chat-rail-travelcards-card__intro" i18n="@@chatTravelcardIntro">
    This train comes with the option of a London travelcard, giving unlimited travel on the
    Underground, buses, trams, DLR and National Rail within the zones shown. Prices are per
    traveller.
  </p>

  <div class="chat-rail-travelcards-card__options" role="radiogroup">
    @for (extra of request.travelcards; track extra; let i = $index) {
      <button
        type="button"
        role="radio"
        class="chat-rail-travelcards-card__option"
        [class.chat-rail-travelcards-card__option--selected]="selectedIndex === i"
        [attr.aria-checked]="selectedIndex === i"
        [disabled]="resolved"
        (click)="select(i)"
      >
        <span class="chat-rail-travelcards-card__option-label">{{ label(extra) }}</span>
        <span class="chat-rail-travelcards-card__option-price">
          {{ price(extra) }}
          @if (childPrice(extra)) {
            <span class="chat-rail-travelcards-card__option-child" i18n="@@chatTravelcardChild"
              >child {{ childPrice(extra) }}</span
            >
          }
        </span>
      </button>
    }
  </div>

  <p class="chat-rail-travelcards-card__warning" i18n="@@chatTravelcardEticketWarning">
    Adding a travelcard means this ticket cannot be delivered as an e-ticket, so you would collect
    it from a station machine instead.
  </p>

  <div class="chat-rail-travelcards-card__footer">
    <button
      type="button"
      appButton="small"
      [disabled]="selectedIndex === null || resolved"
      (click)="addSelected()"
      i18n="@@chatTravelcardAdd"
    >
      Add this travelcard
    </button>
    <button
      type="button"
      appButton="small"
      class="small-button--no"
      [disabled]="resolved"
      (click)="addWithout()"
      i18n="@@chatTravelcardNone"
    >
      No travelcard
    </button>
    <button
      type="button"
      appButton="small"
      class="small-button--no"
      [disabled]="resolved"
      (click)="cancel()"
      i18n="@@chatTravelcardCancel"
    >
      Cancel
    </button>
  </div>

  <p class="chat-rail-travelcards-card__hint" i18n="@@chatTravelcardHint">
    You can also just reply "no travelcard", or "cancel" to drop the train.
  </p>
</div>
